import React from 'react';

interface UnreadPillProps {
  unreadMessagesCount: number;
}

export const UnreadPill: React.FC<UnreadPillProps> = ({ unreadMessagesCount }) => {
  return (
    <div className="flex items-center justify-center py-4">
      <div className="rounded-full bg-gray-200 px-4 py-2">
        <span className="text-sm font-medium text-gray-600">
          {unreadMessagesCount > 99 ? '99+' : unreadMessagesCount}{' '}
          {unreadMessagesCount > 1 ? 'Unread Messages' : 'Unread Message'}
        </span>
      </div>
    </div>
  );
};
